import { FC } from 'react';

type Props = {
	className?: string;
};

const DoorIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12.8167 4.87655C12.6545 4.89702 12.4864 4.91822 12.3101 4.93654L12.1562 3.45618C12.2642 3.44496 12.3881 3.42925 12.5231 3.41214C12.962 3.35653 13.5191 3.28596 14.0274 3.3056C14.7292 3.33272 15.5441 3.52954 16.121 4.26532C16.4529 4.68856 16.5822 5.18413 16.6414 5.71962C16.6983 6.23396 16.6982 6.87816 16.6982 7.65503V12.3441C16.6982 13.121 16.6983 13.7652 16.6414 14.2796C16.5822 14.815 16.4529 15.3106 16.121 15.7338C15.5441 16.4696 14.7292 16.6664 14.0274 16.6936C13.5191 16.7132 12.9621 16.6426 12.5232 16.587C12.3881 16.5699 12.2642 16.5542 12.1562 16.543L12.3101 15.0626C12.4864 15.081 12.6545 15.1021 12.8167 15.1226C13.2241 15.174 13.5953 15.2208 13.9699 15.2063C14.4569 15.1875 14.7547 15.0642 14.9499 14.8154C15.0366 14.7049 15.1166 14.527 15.1621 14.116C15.2088 13.6932 15.2099 13.1318 15.2099 12.3016V7.69758C15.2099 6.86732 15.2088 6.30599 15.1621 5.88316C15.1166 5.47212 15.0366 5.29427 14.9499 5.18376C14.7547 4.93491 14.4569 4.81165 13.9699 4.79284C13.5953 4.77836 13.2241 4.82518 12.8167 4.87655Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.66743 2.02339C10.1471 1.97646 10.5783 1.99092 10.985 2.15273C11.5874 2.39234 12.0867 2.84147 12.4067 3.41674C12.6195 3.79941 12.7074 4.23242 12.7493 4.7364C12.7904 5.23106 12.7904 5.85184 12.7904 6.63247V13.3673C12.7904 14.1479 12.7904 14.7687 12.7493 15.2633C12.7074 15.7673 12.6195 16.2003 12.4067 16.583C12.0867 17.1583 11.5874 17.6074 10.985 17.847C10.5783 18.0088 10.1471 18.0232 9.66743 17.9764C9.19987 17.9306 8.6244 17.8188 7.90945 17.6799L7.85836 17.67C7.16775 17.5358 6.6164 17.4287 6.17316 17.3046C5.71686 17.1768 5.33564 17.021 4.99571 16.7694C4.47084 16.3808 4.05868 15.8509 3.79884 15.2392C3.63211 14.8468 3.55846 14.4291 3.52297 13.9342C3.48827 13.4502 3.48828 12.855 3.48828 12.1017V7.89807C3.48828 7.14475 3.48827 6.54957 3.52297 6.06555C3.55846 5.57065 3.63211 5.15301 3.79884 4.76053C4.05868 4.14882 4.47084 3.61894 4.99571 3.23036C5.33564 2.97871 5.71686 2.82291 6.17316 2.69514C6.6164 2.57103 7.16772 2.46392 7.85831 2.32977L7.90945 2.31984C8.6244 2.18093 9.19987 2.06913 9.66743 2.02339ZM10.5579 9.25565C10.5579 8.94741 10.308 8.69752 9.99978 8.69752C9.69154 8.69752 9.44165 8.94741 9.44165 9.25565V10.744C9.44165 11.0522 9.69154 11.3021 9.99978 11.3021C10.308 11.3021 10.5579 11.0522 10.5579 10.744V9.25565Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.4648 15.75C14.4648 15.339 14.798 15.0059 15.209 15.0059H17.4415C17.8525 15.0059 18.1857 15.339 18.1857 15.75C18.1857 16.161 17.8525 16.4942 17.4415 16.4942H15.209C14.798 16.4942 14.4648 16.161 14.4648 15.75Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1.8125 15.9536C1.8125 15.5426 2.14568 15.2095 2.55667 15.2095H4.78918C5.20018 15.2095 5.53336 15.5426 5.53336 15.9536C5.53336 16.3646 5.20018 16.6978 4.78918 16.6978H2.55667C2.14568 16.6978 1.8125 16.3646 1.8125 15.9536Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default DoorIconSolid;
